import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-error-button',
  templateUrl: './error-button.component.html',
  styleUrls: ['./error-button.component.css']
})
export class ErrorButtonComponent {


  @Input() icon: string;
  @Input() buttonText: string;
  @Input() text: string;


  constructor() { }


}
